/**
 * wql
 * @description 证书挂靠管理列表
 * @Date 2020/9/18
 */
import React from 'react'
import { component_tool } from '../../../tool';
import { WizTableForm } from '../../common'
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
};
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1} })
let { WizModal } = component_tool;
import SelectLinkOrg from './selectLinkOrg'
import SetsRoleSelect from "../../auth/roleSets/setsRoleSelect";
import moment from "moment";

//配置项
let componentName = 'certLink'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "personId",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "姓名",
    name: "fullName",
    searchItem: {}
  },
  {
    title: "账号",
    name: "userName",
    searchItem: {}
  },
  {
    title: "所属状态",
    name: "state",
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 0, codeName: '正常' },
      { code: 1, codeName: '待确认' },
      { code: 2, codeName: '无' },
    ],
  },
  {
    title: "组织",
    name: "orgId",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...organizationConfig
    }
  },


  {
    title: "账号",
    name: "userName",
    tableItem: {
      width: 70
    },
  },
  {
    title: "姓名",
    name: "fullName",
    tableItem: {
      width: 70
    },
  },
  {
    title: "身份证号/工号",
    name: "idCard",
    tableItem: {
      width: 200
    },
  },
  {
    title: "账号状态",
    name: "userState",
    tableItem: {
      width: 100
    },
    dict: [
      { code: 1, codeName: '激活' },
      { code: 0, codeName: '禁用' },
    ],
  },
  {
    title: "证书名称",
    name: "certName",
    searchItem: {},
    tableItem: {
      width: 200
    },
  },
  {
    title: "主证书状态",
    name: "certMasterState",
    dict: [
      { code: 1, codeName: '有效' },
      { code: 0, codeName: '无效' },
    ],
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "是否允许共建",
    name: "allowUnite",
    dict: [
      { code: 0, codeName: '否' },
      { code: 1, codeName: '是' },
    ],
    tableItem: {
      width: 100
    },
  },
  {
    title: "获得途径",
    name: "channel",
    tableItem: {
      width: 150
    },
  },
  {
    title: "获得时间",
    name: "certDate",
    tableItem: {
      width: 100,
      render: text => {
        return formatterDate(text)
      }
    },
    searchItem: {
      type: 'date~',
      format: 'YYYY-MM-DD',
    }
  },
  {
    title: "导入时间",
    name: "recordCreateTime",
    tableItem: {
      width: 100,
      render: text => {
        return formatterDate(text)
      }
    },
    searchItem: {
      type: 'date~',
      format: 'YYYY-MM-DD',
    }
  },
  {
    title: "所属状态",
    name: "state",
    tableItem: {
      width: 100
    },
    dict: [
      { code: 0, codeName: '正常' },
      { code: 1, codeName: '待确认' },
      { code: 2, codeName: '无' },
    ],
  },
  {
    title: "所属组织名称",
    name: "orgName",
    tableItem: {
      width: 100
    }
  },
  {
    title: "所属组织编码",
    name: "orgCode",
    tableItem: {
      width: 100
    }
  },
  {
    title: "区域",
    name: "regionName",
    tableItem: {
      width: 100
    }
  },
  {
    title: "是否共建店",
    name: "dealerUnite",
    tableItem: {
    }
  },
];

const templateConfig = (date) => {
  const {onSelect,_btnLookUserFun,_this} = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  return {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        dataFormat: (v) => {
          let value = Object.assign([], v)
          if (value['certDate'] && value['certDate'].length === 2) {
            value['certDateStart'] = moment(value['certDate'][0]).format("YYYY-MM-DD 00:00:00")
            value['certDateEnd'] = moment(value['certDate'][1]).format("YYYY-MM-DD 23:59:59")
          }
          if (value['recordCreateTime'] && value['recordCreateTime'].length === 2) {
            value['recordCreateTimeStart'] = moment(value['recordCreateTime'][0]).format("YYYY-MM-DD 00:00:00")
            value['recordCreateTimeEnd'] = moment(value['recordCreateTime'][1]).format("YYYY-MM-DD 23:59:59")
          }
          // delete value['certDate']
          // delete value['recordCreateTime']
          return value
        },
        buttonSort:['addOrg','orgConfirm','modifyOrg','cancelOrg','import','export'],
        buttons: [
          {
            key: "addOrg",
            name: "WizButton",
            params: {children: '添加所属组织', type: 'primary'},
            onClick: e => {
              if (e.rows.length != 1){
                wizNotice.warn("请选择一条挂靠信息！");
                return null
              }
              if (e.rows[0].state != 2){
                wizNotice.warn("只有状态为无的信息才能添加组织！");
                return null
              }
              e.record = e.rows;
              _btnLookUserFun && _btnLookUserFun(e)
            }
          },
          {
            key: "orgConfirm",
            custom: true,
            params: {children: '所属组织确认', type: 'primary', },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (rows.length != 1){
                  wizNotice.warn("请选择一条挂靠信息！");
                  return null
                }
                let rowData = rows[0];
                if (rowData.state != 1){
                  wizNotice.warn("只有待确认的信息才可以做确认操作！");
                  return null
                }
                const content = `您确定要${
                  rowData['state'] === 0 ? "取消" : rowData['state'] === 1 ? "挂靠" : ""
                }到${rowData['orgName']}为学员${rowData['fullName']}的${rowData['certName']}所属组织？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: 0,
                      personId:rowData['personId'],
                      id: rowData['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "modifyOrg",
            name: "WizButton",
            params: {children: '修改所属组织', type: 'primary'},
            onClick: e => {
              if (e.rows.length != 1){
                wizNotice.warn("请选择一条挂靠信息！");
                return null
              }
              if (e.rows[0].state != 0){
                wizNotice.warn("只有状态为正常的信息才能修改组织！");
                return null
              }
              e.record = e.rows;
              _btnLookUserFun && _btnLookUserFun(e)
            }
          },
          {
            key: "cancelOrg",
            custom: true,
            params: {children: '取消所属组织', type: 'danger'},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (rows.length != 1){
                  wizNotice.warn("请选择一条挂靠信息！");
                  return null
                }
                let rowData = rows[0];
                if (rowData.state != 0){
                  wizNotice.warn("只有正常的信息才可以做取消操作！");
                  return null
                }
                // const content = `您确定要${
                //   rowData['state'] === 0 ? "取消" : rowData['state'] === 1 ? "挂靠" : ""
                // }到${rowData['orgName']}为学员${rowData['fullName']}的${rowData['certName']}所属组织？`;
                const content = `您确定${
                    rowData['state'] === 0 ? "取消" : rowData['state'] === 1 ? "挂靠" : ""
                 }该学员的所属组织吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: 2,
                      personId:rowData['personId'],
                      id: rowData['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: 'import',
            custom: true,
            params: { icon: 'import', children: '导入', type: 'import'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/certLink/certLinkImport',
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
    }
  }}
};


const apis = {
  list: {
    path: `certLink/getPageList`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  updateState:{
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },
  enable: {
    path: `certLink/updateLinkState`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  import: {
    path: `${componentName}/exportTrainPathInfo`,
    payload: {
      key: `${componentName}@exportTrainPathInfo`,
      apiParams: {}
    }
  },
  export: {
    path: `certLink/getList`,
    payload: {
      key: `${componentName}@getPathContent`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
